import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "@fluentui/react-theme-provider";
import { StatusBadge, Table, TableContainer, Wrapper, ActionsCell } from "./PortfolioOrdersStyle";
import { parseNumber } from "../../../utils/toFixedDecimals";
import { Link, useHistory } from "react-router-dom";
import { ActivateOrdersIcon, DeleteIcon, RedEye12Icon } from "@fluentui/react-icons-mdl2";
import { DefaultButton, mergeStyleSets, Modal, Spinner, SpinnerSize, TeachingBubble, TooltipHost } from "@fluentui/react";
import { typeOfCancelDevolution } from "../../../config";
import { decimalFormatter, longDecimalFormatter } from "../../../utils/numberFormatter";
import MovementsTable from "./MovementsTable";
import { useBoolean } from "@fluentui/react-hooks";
import FinametrixService from "../../../services/FinametrixService";
import moment from "moment";
import { TPortfolioOrderDataRows, TColumnsPortofolioOrders } from "./types/TPorfolioOrders";

type TPortfolioOrdersTableNew = {
    data: TPortfolioOrderDataRows[];
    columns: TColumnsPortofolioOrders[];
    rowSelected: (row: TPortfolioOrderDataRows) => void;
    toggleRow: any;
};

const contentStyles = mergeStyleSets({
    container:
    {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
        padding: '45px',
        borderRadius: '16px',
        selectors:
        {
            h3:
            {
                textAlign: 'center',
                marginBottom: '20px'
            }
        },
    }
});

const PortfolioOrdersTableNew = (props: TPortfolioOrdersTableNew) =>
{
    const theme = useContext(ThemeContext);
    let history = useHistory();
    const [incidenceTooltip, setIncidenceTooltip] = useState("");
    const [isModalOpen, {setTrue: showModal, setFalse: hideModal}] = useBoolean(false);

    useEffect(() =>
    {
        caches.keys().then((names) =>
        {
            names.forEach((name) =>
            {
                caches.delete(name);
            });
        });
    }, []);

    const downloadBase64Pdf = (event: any, operationId: string) =>
    {
        event.preventDefault();
        showModal();

        FinametrixService.getOperationBase64Pdf(operationId).then((response: any) =>
        {
            var downloadLink = document.createElement("a");
            downloadLink.download = `voucher-${operationId}.pdf`;
            downloadLink.href = response;
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            hideModal();
        })
        .catch((error) =>
        {
            console.log(error);
        });
    };

    return(
        <Wrapper>
            <TableContainer>
                <Table theme={theme} style={{tableLayout: "fixed"}}>
                    <thead>
                        <tr>
                            {props.columns.map((column: any, columnIndex: any) =>
                            {
                                return <th key={"head-" + columnIndex} style={column.style}>{column.title}</th>;
                            })}
                        </tr>
                    </thead>
                    {props.data.map((row: any, rowIndex: any) =>
                    {
                        let amount;

                        if(row.amount === "Total")
                        {
                            amount = "Total";
                        }
                        else
                        {
                            if(row.amount.includes("participaciones"))
                            {
                                amount = longDecimalFormatter.format(parseFloat(row.amount.match(/[\d.]+/)[0])) + " participaciones";
                            }
                            else
                            {
                                amount = decimalFormatter.format(parseNumber(row.amount, 2))+"€";
                            }
                        }

                        return (
                            <tbody
                                key={"row-"+rowIndex}
                                style={{ display: 'table-row-group', borderBottom: '1px solid #ecf1f3' }}
                            >
                                <tr style={{verticalAlign: "middle"}}>
                                    <td>
                                        {row.movements && row.movements.length > 0 && (
                                            <DefaultButton className={"button collapse-link" + (row.collapsed ? '' : ' expanded')} onClick={() => props.toggleRow(row)}> </DefaultButton>
                                        )}
                                    </td>
                                    <td style={{padding: "1em"}}>{moment(row.date).format("DD/MM/YYYY")}</td>
                                    <td style={{paddingRight: "15px"}}>
                                        <StatusBadge className={row.status.name.toLowerCase()} theme={theme}>
                                            {row.status.name}
                                        </StatusBadge>
                                    </td>
                                    <td style={{padding: "1em"}}>
                                        <div>
                                            {row.type === "subscription" &&
                                            (
                                                <p>
                                                    <span className="fund-name" style={{color: "rgb(66,132,230)", cursor: "pointer"}}
                                                        onClick={() => history.push(`/${row.fund.isinOrig}`)}
                                                    >
                                                        {row.fund.isinOrig}
                                                        {" - "}
                                                        {row.fund.nameOrig}
                                                    </span>
                                                </p>
                                            )}
                                            {row.type === "refund" &&
                                            (
                                                <>
                                                    <p>
                                                        Origen:{" "}
                                                        <span className="fund-name" style={{color: "rgb(66,132,230)", cursor: "pointer"}}
                                                            onClick={() => history.push(`/${row.fund.isinOrig}`)}
                                                        >
                                                            {row.fund.isinOrig}
                                                            {" - "}
                                                            {row.fund.nameOrig}
                                                        </span>
                                                    </p>
                                                    <p>
                                                        IBAN Destino:{" "}
                                                        <span className="iban">{row.iban}</span>
                                                    </p>
                                                </>
                                            )}
                                            {!["subscription", "refund"].includes(row.type) &&
                                            (
                                                <React.Fragment>
                                                    <p>
                                                        Origen:{" "}
                                                        <span className="fund-name" style={{color: "rgb(66,132,230)", cursor: "pointer"}}
                                                            onClick={() => history.push(`/${row.fund.isinOrig}`)}
                                                        >
                                                            {row.fund.isinOrig}
                                                            {" - "}
                                                            {row.fund.nameOrig}
                                                        </span>
                                                    </p>
                                                    {row.fund.nameDesty === "" ? null :
                                                    (
                                                        <p>
                                                            Destino:{" "}
                                                            <span
                                                                className="fund-name"
                                                                style={{color: "rgb(66,132,230)", cursor: "pointer"}}
                                                                onClick={() => history.push(`/${row.fund.isinDesty}`)}
                                                            >
                                                                {row.fund.isinDesty}
                                                                {" - "}
                                                                {row.fund.nameDesty}
                                                            </span>
                                                        </p>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </td>
                                    <td>{row.status.message}</td>
                                    <td style={{padding: "1em"}}>
                                        <p>{row.typeText}</p>
                                    </td>
                                    <td style={{padding: "1em"}}>
                                        <p style={{textAlign: "right"}}>
                                            <span className="price-no-wrap">
                                                {amount}
                                            </span>
                                        </p>
                                    </td>
                                    <ActionsCell theme={theme}>
                                        {row.incidence &&
                                        (
                                            <>
                                                <Link to={`/portfolio/orders/${row.finametrixId}`}
                                                    onMouseEnter={() => setIncidenceTooltip(row.finametrixId)}
                                                    onMouseLeave={() => setIncidenceTooltip("")}
                                                >
                                                    <ActivateOrdersIcon id={`orderIncidence${rowIndex}`} />
                                                </Link>
                                                {row.finametrixId === incidenceTooltip &&
                                                (
                                                    <TeachingBubble target={`#orderIncidence${rowIndex}`}
                                                        hasCloseButton={false}
                                                        headline="Orden con incidencia"
                                                    >
                                                        Esta orden tiene una incidencia, pulsa para
                                                        resolverla.
                                                    </TeachingBubble>
                                                )}
                                            </>
                                        )}
                                        {row.status.name === "Validada" 
                                        && (row.type === "internal_switch" || row.type === "external_switch" || row.type === "subscription" )  && (Number(typeOfCancelDevolution) === 1 ?
                                        (
                                            <Link to={
                                                {
                                                    pathname: `/portfolio/orders/cancel/a/${row.finametrixId}`,
                                                    state:
                                                    {
                                                        date: row.date,
                                                        status: row.status.name,
                                                        statusMessage: row.status.message,
                                                        typeText: row.typeText,
                                                        amount: row.amount,
                                                        isinOrig: row.fund.isinOrig,
                                                        nameOrig: row.fund.nameOrig,
                                                        isinDesty: row.fund.isinDesty,
                                                        nameDesty: row.fund.nameDesty,
                                                        type: row.type,
                                                        iban: row.iban,
                                                    }
                                                }}
                                                onMouseEnter={() => setIncidenceTooltip(row.finametrixId)}
                                                onMouseLeave={() => setIncidenceTooltip("")}
                                            >
                                                <TooltipHost content="Cancelar Orden" id={`order-cancel`}>
                                                    <DeleteIcon id={`orderCancel${rowIndex}`} />
                                                </TooltipHost>
                                            </Link>
                                        ) :
                                        (
                                            <Link to={{pathname: `/portfolio/orders/cancel/m/${row.finametrixId}`,
                                                state:
                                                {
                                                    date: row.date,
                                                    status: row.status.name,
                                                    statusMessage: row.status.message,
                                                    typeText: row.typeText,
                                                    amount: row.amount,
                                                    isinOrig: row.fund.isinOrig,
                                                    nameOrig: row.fund.nameOrig,
                                                    isinDesty: row.fund.isinDesty,
                                                    nameDesty: row.fund.nameDesty,
                                                    type: row.type,
                                                    iban: row.iban,
                                                }}}
                                                onMouseEnter={() => setIncidenceTooltip(row.finametrixId)}
                                                onMouseLeave={() => setIncidenceTooltip("")}
                                            >
                                                <TooltipHost content="Cancelar Orden" id={`order-cancel`}>
                                                    <DeleteIcon id={`orderCancel${rowIndex}`} />
                                                </TooltipHost>
                                            </Link>
                                        ))}
                                        {(row.typeText === "Traspaso externo"
                                        || row.typeText === "Traspaso interno")
                                        //  && row.status.name !== "Error"
                                        //  && row.status.name !== "Finalizado"
                                        //  && row.status.name !== "Cancelada"
                                         && (
                                            <TooltipHost content="Simular" id={`Simular`}>
                                                <RedEye12Icon id={"Simulation"} className="icons-table" onClick={() => props.rowSelected(row)} />
                                            </TooltipHost>
                                        )}
                                    </ActionsCell>
                                </tr>
                                {row.movements && row.movements.length > 0 && !row.collapsed && (
                                    <tr>
                                        <td colSpan={8} style={{paddingLeft: '45px', paddingBottom: '20px'}}>
                                            <MovementsTable movements={row.movements} downloadBase64Pdf={downloadBase64Pdf} />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        );
                    })}
                </Table>
            </TableContainer>
            {isModalOpen && (
                <Modal isOpen={isModalOpen}
                    onDismiss={hideModal}
                    containerClassName={contentStyles.container}
                    isBlocking={false}
                >
                    <h3>Descargando archivo</h3>
                    <Spinner size={SpinnerSize.large} />
                </Modal>
            )}
        </Wrapper>
    );
};

export default PortfolioOrdersTableNew;